function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-machine-encryption",
  d: "M309.21,422.9v2.23a7.5,7.5,0,0,1-15,0V422.9h0v-3.35h1l.12-1.78a6.31,6.31,0,0,1,6.41-6.22,6.19,6.19,0,0,1,6.39,5.62l.08,2.38h1v3.35Zm-7.5,2.24a1.23,1.23,0,1,0-1.25-1.23A1.24,1.24,0,0,0,301.71,425.14Zm0-11.07a3.82,3.82,0,0,0-3.75,3.17l.25,2.31h7l.25-2.31A3.82,3.82,0,0,0,301.71,414.06Z",
  transform: "translate(-294.21 -411.54)"
});

var SvgEncryption = function SvgEncryption(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg_machine_encryption_icon_layer",
    "data-name": "Layer 1",
    viewBox: "0 0 15 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEncryption, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/encryption.33ca99b6.svg";
export { ForwardRef as ReactComponent };